'use client';

import { DefaultPanelLayout, HeadlessPanelLayout } from './Layouts';
import {
  LeftSidebar,
  PanelHeader,
  PanelLayoutTitle,
  PanelHeaderContent,
  PanelHeaderTabs,
  PanelLayoutLoader,
  PanelMainContent,
  PanelLayoutProvider,
  RightSidebar,
  usePanelLayout,
} from './PanelLayoutContext';

export * from './Layouts';
export * from './PanelLayout.constants';
export * from './PanelLayout.enums';
export * from './PanelTabHeader';
export * from './Controls';
export * from './Panels/ThreeColumnPanel';

export { PanelLayoutLoader, PanelLayoutProvider, usePanelLayout };

export const Layouts = {
  Default: DefaultPanelLayout,
  Headless: HeadlessPanelLayout,
} as const;

export { DefaultPanelLayout as LayoutDefault, HeadlessPanelLayout as LayoutHeadless };

const PanelHeaderNamespace = Object.assign(PanelHeader, {
  Content: PanelHeaderContent,
  Tabs: PanelHeaderTabs,
  Title: PanelLayoutTitle,
});

export const PanelComponents = {
  Header: PanelHeaderNamespace,
  LeftSidebar,
  MainContent: PanelMainContent,
  RightSidebar,
} as const;
